// Hero.jsx
import React, { useState } from 'react';
import { Shield } from 'lucide-react';
import { designTokens, styles } from './MainPage.styles';

export default function Hero({ scrollToSection }) {
  const [hoveredBtn, setHoveredBtn] = useState(null);

  return (
    <section id="home" style={styles.hero}>
      {/* Updated Scoped CSS to include your requested margin adjustment */}
      <style>{`
        /* Mobile & Tablet adjustment */
        @media (max-width: 768px) {
          .hero-inner-custom {
            margin-top: -48px !important;
          }
          .hero-actions-container {
            flex-direction: column !important;
            width: 100%;
            gap: 12px !important;
          }
          .responsive-hero-btn {
            width: 100% !important;
            text-align: center;
          }
        }
      `}</style>

      {/* Added the class 'hero-inner-custom' to target the margin */}
      <div style={styles.heroInner} className="hero-inner-custom">
        <div style={styles.heroTag}>
          <Shield size={14} style={{ color: designTokens.gold }} />
          <span>Proprietary Compliance Technology — SureShot Books Publishing LLC</span>
        </div>
        
        <h1 style={styles.heroH1}>
          Automated Book<br />Policy Compliance<br /><span style={{ color: designTokens.gold }}>For Every Facility.</span>
        </h1>
        
        <p style={styles.heroDesc}>
          BookPolicyGuard™ enforces your facility's exact book policies before a single package ships. No more rejected mail. No more mailroom burden. No more contraband risk from printed materials.
        </p>
        
        <div style={{ ...styles.heroActions, gap: '16px' }} className="hero-actions-container">
          {/* PRIMARY BUTTON */}
          <button 
            type="button" 
            className="responsive-hero-btn"
            onClick={() => scrollToSection('apply')} 
            style={{
              ...styles.btnPrimary,
              padding: '16px 36px',
              boxSizing: 'border-box',
              border: '2px solid transparent',
              transform: hoveredBtn === 'primary' ? 'translateY(-3px)' : 'translateY(0)',
              backgroundColor: hoveredBtn === 'primary' ? designTokens.goldLight : designTokens.gold,
              boxShadow: hoveredBtn === 'primary' ? '0 10px 35px rgba(249, 229, 71, 0.45)' : '0 6px 30px rgba(212,172,13,0.25)'
            }}
            onMouseEnter={() => setHoveredBtn('primary')}
            onMouseLeave={() => setHoveredBtn(null)}
          >
            Apply to Become Approved Facility →
          </button>

          {/* SECONDARY BUTTON */}
          <button 
            type="button" 
            className="responsive-hero-btn"
            onClick={() => scrollToSection('how')} 
            style={{
              ...styles.btnSecondary,
              padding: '16px 36px',
              boxSizing: 'border-box',
              transform: hoveredBtn === 'secondary' ? 'translateY(-3px)' : 'translateY(0)',
              backgroundColor: '#112235', 
              borderColor: hoveredBtn === 'secondary' ? designTokens.gold : 'rgba(255, 255, 255, 0.15)',
              color: hoveredBtn === 'secondary' ? designTokens.gold : designTokens.white,
              boxShadow: hoveredBtn === 'secondary' ? `0 0 20px rgba(212, 172, 13, 0.3)` : 'none'
            }}
            onMouseEnter={() => setHoveredBtn('secondary')}
            onMouseLeave={() => setHoveredBtn(null)}
          >
            See How It Works
          </button>
        </div>
      </div>
    </section>
  );
}